import { useTranslation } from "next-i18next";

const useBookingTranslation = () => {
  return useTranslation("booking");
};

export default useBookingTranslation;
